import Cookies from "js-cookie";

export const useLogout = () => {
  Cookies.remove('authToken')
  window.location.replace('/');
  window.history.replaceState({}, document.title, window.location.pathname);
  localStorage.removeItem('username')
  localStorage.removeItem('bearerToken')
}
